@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.rate-comparison-wrapper {
  display: flex;
  justify-content: center;
  padding: 5px;
  background-color: @fulfillment-planner--rate-recommendation--background-color;
  font-size: 13px;
  text-align: center;

  button {
    font-size: 13px;
  }
}

.demo-pill {
  padding: 0 10px 2px;
  border-radius: 10px;
  min-height: 18px;
}
